<template>
    <div>
        <az-back-button style="margin-top: 20px !important;" :route="{name: rotaOrigem}" text="Voltar para listagem"/>

        <div class="az-container">
          <menu-processo-visualizacao v-model="compraDireta" @downloadAnexo="tratarEventDownloadAnexo"/>
          <div class="az-form-content">

                <detalhes-compra-direta-acoes v-model="compraDireta"
                                              v-if="compraDireta.lotes.length > 0 || compraDireta.itens.length > 0"
                                              @lancarProposta="tratarEventoDeLancarProposta"
                                              @continuarProposta="tratarEventoVerProposta"
                                              @visualizarProtocolo="tratarEventoVerProtocolo"
                                              @visualizarDisputa="tratarEventoIrParaDisputa"
                                              @visualizarResultado="tratarEventoVerResultado"
                                              @gerarRelatorioDaAta="gerarRelatorioDaAta"
                                              @buscarDetalhes="buscarDetalhesDaCompraDireta"
                                              class="mb-4"/>

                <v-container fluid grid-list-xl white class="mb-4">

                    <painel-compra-direta-visualizacao v-model="compraDireta"
                                                       :exibirFimEnvioPropostasELances="exibirFimEnvioPropostasELances"
                                                       :tempoRandomicoLance="compraDireta.tempoRandomicoLance"
                                                       :ehCompraPropostaManualEhAtiva="ehCompraPropostaManualEhAtiva"/>

                    <painel-anexo-visualizacao v-model="documentosVisiveis"
                                               :documentos="documentos"
                                               :paginas="null"
                                               :paginacao="null"
                                               @downloadAnexo="tratarEventDownloadAnexo"/>

                    <painel-linha-fornecimento-visualizacao v-model="compraDireta.linhasFornecimento" titulo="Linhas de Fornecimento do Processo"/>

                    <painel-lote-visualizacao v-if="compraDireta.lotes.length > 0"
                                              v-model="compraDireta.lotes"
                                              :possuiValorReferencia="compraDireta.possuiValorReferencia"
                                              :exibirValorDeReferencia="compraDireta.exibeValorReferencia"
                                              :prefixSuffixValor="prefixSuffixValor"
                                              :criterioJulgamento="criterioJulgamento"
                                              :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                              :casasDecimais="compraDireta.casaDecimal"
                                              :casasDecimaisQuantidade="compraDireta.casasDecimaisQuantidade"/>

                    <painel-item-visualizacao v-if="compraDireta.itens.length > 0"
                                              v-model="compraDireta.itens"
                                              :possuiValorReferencia="compraDireta.possuiValorReferencia"
                                              :exibirValorDeReferencia="compraDireta.exibeValorReferencia"
                                              :prefixSuffixValor="prefixSuffixValor"
                                              :criterioJulgamento="criterioJulgamento"
                                              :isCriterioJulgamentoMaiorDesconto="isCriterioJulgamentoMaiorDesconto"
                                              :casasDecimais="compraDireta.casaDecimal"
                                              :casasDecimaisQuantidade="compraDireta.casasDecimaisQuantidade"/>

                    <div class="total total-listagem" v-if="!isCriterioJulgamentoMaiorDesconto && (possuiLoteItem && compraDireta.exibeValorReferencia
                     && compraDireta.possuiValorReferencia)">
                        <p>
                            <strong>Total Geral: </strong> {{ totalGeral | cdCurrency(prefix, compraDireta.casaDecimal) }}{{suffix}}
                        </p>
                    </div>
                </v-container>

                <detalhes-compra-direta-acoes v-model="compraDireta"
                                              v-if="compraDireta.lotes.length > 0 || compraDireta.itens.length > 0"
                                              :desabilitarBaixarAta="isBaixandoAta"
                                              @lancarProposta="tratarEventoDeLancarProposta"
                                              @continuarProposta="tratarEventoVerProposta"
                                              @visualizarProtocolo="tratarEventoVerProtocolo"
                                              @visualizarDisputa="tratarEventoIrParaDisputa"
                                              @visualizarResultado="tratarEventoVerResultado"
                                              @gerarRelatorioDaAta="gerarRelatorioDaAta"/>
            </div>
        </div>

        <alert :exibir.sync="exibirAlertaValidarFornecedor"
               :mensagem="mensagemErro"
               :link="linkMensagemErro"
               :isAlertaAmarelo="alertaAmarelo"
               class="alerta-validar-fornecedor"
               @fechar="exibirAlertaValidarFornecedor = false"
        />

    </div>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes, criteriosJulgamento, mutationTypes} from '@/core/constants'
import PainelCompraDiretaVisualizacao from '@/views/pages/commons/painel/painel-compra-direta/PainelCompraDiretaVisualizacao'
import PainelAnexoVisualizacao from '@/views/pages/commons/painel/painel-anexo/PainelAnexoVisualizacao'
import PainelItemVisualizacao from '@/views/pages/fornecedor/detalhes-compra-direta/painel-item/PainelItemVisualizacao'
import PainelLoteVisualizacao from '@/views/pages/fornecedor/detalhes-compra-direta/painel-lote/PainelLoteVisualizacao'
import PainelLinhaFornecimentoVisualizacao from '@/views/pages/fornecedor/detalhes-compra-direta/painel-linha-fornecimento/PainelLinhaFornecimentoVisualizacao'
import DetalhesCompraDiretaAcoes from '@/views/pages/fornecedor/detalhes-compra-direta/DetalhesCompraDiretaAcoes'
import MenuProcessoVisualizacao from '@/views/pages/commons/painel/painel-processo/MenuProcessoVisualizacao'

export default {
    name: 'DetalhesCompraDireta',
    components: {
        PainelLinhaFornecimentoVisualizacao,
        PainelLoteVisualizacao,
        PainelItemVisualizacao,
        PainelAnexoVisualizacao,
        PainelCompraDiretaVisualizacao,
        DetalhesCompraDiretaAcoes,
        MenuProcessoVisualizacao
    },
    data() {
        return {
            compraDiretaId: null,
            propostaId: null,
            documentos: [],
            isBaixandoAta: false,
            rotaOrigem: this.$store.state.rota.origem,
            exibirAlertaValidarFornecedor: false,
            mensagemErro: '',
            linkMensagemErro: null,
            alertaAmarelo: false,
        }
    },
    computed: {
        ...mapState(['compraDireta', 'fornecedor', 'parametros']),
        possuiLoteItem() {
            return (this.compraDireta && this.compraDireta.itens && this.compraDireta.lotes && 
                    this.compraDireta.itens.length > 0 && this.compraDireta.lotes.length > 0)
        },
        exibirFimEnvioPropostasELances(){
            return this.compraDireta && this.compraDireta.amparoLegal ? 
                this.exibirFimPropostasELances(this.compraDireta.amparoLegal) : false
        },
        totalGeral() {
            if (this.possuiLoteItem) {
                let totalLotes = 0
                let totalItens = 0
                this.compraDireta.lotes.forEach(lote => {
                    totalLotes += lote.totalUnitario || 0
                })
                this.compraDireta.itens.forEach(item => {
                    totalItens += item.valorEstimado || 0
                })
                return totalLotes + totalItens
            } else {
                return 0
            }
        },
        documentosVisiveis() {
            return this.compraDireta && this.compraDireta.anexos ? 
                this.compraDireta.anexos.filter(anexo => anexo.situacao === 'ATIVO') : []
        },
        fourbillingAtivo(){
            if(this.parametros && this.parametros.propriedadesCompraDiretas && 
               this.parametros.propriedadesCompraDiretas.sistemaVerificacaoPlano === 'pagamentos')
                return this.parametros.propriedadesCompraDiretas.integration && 
                       this.parametros.propriedadesCompraDiretas.integration.sistemaDePagamentos === '4billing'
            return false
        },
        criterioJulgamento(){
            return this.compraDireta ? this.compraDireta.criterioJulgamento : null
        },
        prefixSuffixValor(){
            return this.compraDireta ? this.compraDireta.prefixoValor : null
        },
        prefix(){
            return this.compraDireta && this.compraDireta.prefixoValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.compraDireta && this.compraDireta.prefixoValor === '%' ? '%' : ''
        },
        isCriterioJulgamentoMaiorDesconto(){
            return this.compraDireta && this.compraDireta.criterioJulgamento === criteriosJulgamento.MAIOR_DESCONTO.valor
        },
        ehCompraPropostaManualEhAtiva() {
            return this.propostaManualAtiva && this.amparoLegalEhLei14133Art75VIII
        },
        propostaManualAtiva() {
            return Boolean(this.parametros.propriedadesCompraDiretas.propostaManual)
        },
        amparoLegalEhLei14133Art75VIII() {
            const lei = this.compraDireta?.amparoLegal?.lei || ''
            return typeof lei === 'string' && lei.includes('Lei 14.133/2021, Art. 75, VIII')
        }
    },
    created() {
        this.setCompraDiretaId()
    },
    async mounted() {
        try {
            this.$store.commit(mutationTypes.SET_RETRAIR_MENU)
            await this.buscarDocumentos()
            await this.buscarDetalhesDaCompraDireta()
            await this.buscarParametrosDaCompraDireta()
            if(this.$store.state.compraDireta.situacao === 'EM_ELABORACAO') {
                this.$router.push({
                    name: 'CompraDiretaErro',
                })
            }
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDocumentos() {
            if (!this.compraDiretaId) {
                this.setCompraDiretaId()
            }
            if (!this.compraDiretaId) {
                return
            }
            await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS, this.compraDiretaId)
            this.documentos = this.$store.state.documentos
        },
        async buscarDetalhesDaCompraDireta() {
            if (!this.compraDiretaId) {
                this.setCompraDiretaId()
            }
            if (!this.compraDiretaId) {
                return
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DETALHES_DA_COMPRA_DIRETA, this.compraDiretaId)
        },
        async verificarSeFornecedorPossuiLoteItemVencedor() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.VERIFICAR_SE_POSSUI_LOTE_ITEM_VENCEDOR, this.compraDiretaId)
        },
        async buscarParametrosDaCompraDireta() {
            await this.$store.dispatch(actionTypes.BUSCAR_PARAMETROS)
        },
        setCompraDiretaId() {
            this.compraDiretaId = this.$route.params.id
        },
        async tratarEventoDeLancarProposta() {
            let fornecedorValido = null
            if(this.fourbillingAtivo){
                try {
                    fornecedorValido = await this.$store.dispatch(actionTypes.FORNECEDOR.VALIDAR_PARA_PROPOSTA, this.compraDiretaId)
                } catch (err) {
                    if (err.message.includes('plano')){
                        this.mensagemErro = err.message
                        this.linkMensagemErro = {
                            texto: 'Visualizar Planos',
                            url: this.parametros.propriedadesCompraDiretas.urlVisualizarPlanos,
                            redirecionar: false
                        }
                        this.alertaAmarelo = true
                        this.exibirAlertaValidarFornecedor = true
                    } else {
                        throw new Error(err.message)
                    }
                }
            }else{
                fornecedorValido = await this.$store.dispatch(actionTypes.FORNECEDOR.VALIDAR_PARA_PROPOSTA, this.compraDiretaId)
            }

            if (fornecedorValido) {
                await this.$store.dispatch(actionTypes.FORNECEDOR.CRIAR_TERMOS, this.compraDiretaId)
                this.propostaId = this.$store.state.termos.id
                this.irParaTermos()
            }
        },
        tratarEventoVerProposta() {
            if (this.compraDireta.termosTotalmentePreenchidos) {
                this.$router.push({
                    name: 'PropostaDoFornecedor',
                    params: {
                        id: this.compraDiretaId,
                        propostaId: this.compraDireta.propostaId
                    }
                })
            } else {
                this.$router.push({
                    name: 'TermoDoFornecedor',
                    params: {
                        id: this.compraDiretaId,
                        propostaId: this.compraDireta.propostaId
                    }
                })
            }
        },
        tratarEventoVerProtocolo() {
            this.$router.push({
                name: 'ProtocoloDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.compraDireta.propostaId
                }
            })
        },
        tratarEventoIrParaDisputa() {
            this.$router.push({
                name: 'LanceDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.compraDireta.propostaId
                }
            })
        },
        async tratarEventoVerResultado() {
            await this.verificarSeFornecedorPossuiLoteItemVencedor()
            if (this.fornecedor.possuiLoteItemVencedor) {
                await this.$router.push({
                    name: 'DocumentoPropostaDoFornecedor',
                    params: {
                        id: this.compraDiretaId,
                        propostaId: this.compraDireta.propostaId
                    }
                })
            } else {
                await this.$router.push({
                    name: 'ResultadoFinalDoFornecedor',
                    params: {
                        id: this.compraDiretaId,
                        propostaId: this.compraDireta.propostaId
                    }
                })
            }
        },
        irParaTermos() {
            this.$router.push({
                name: 'TermoDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        async gerarRelatorioDaAta() {
            if (this.isBaixandoAta) {
                this.mostrarNotificacaoErro('Já existe um download em andamento. Aguarde a finalização.')
                return
            }
            this.isBaixandoAta = true
            try {
                await this.$store.dispatch(actionTypes.BAIXAR_RELATORIO_DA_ATA_DA_COMPRA_DIRETA, this.compraDiretaId)
                this.mostrarNotificacaoSucesso('Relatório da Ata baixado com sucesso!')
            } finally {
                this.isBaixandoAta = false
            }
        },
        async tratarEventDownloadAnexo(anexoInfo){
            const anexoDoc = anexoInfo.anexo
            if(anexoDoc.id && anexoDoc.uri)
                await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, anexoDoc)
            else{
                const dados = {
                    compraDiretaId: this.compraDiretaId,
                    idVirtualizado: anexoDoc.idVirtualizado,
                    nomeArquivo: anexoDoc.nomeDocumento,
                    opcaoDownloadVirtualizacao: anexoInfo.tipoDownload,
                    noProcessoDigital: anexoDoc.noProcessoDigital
                }
                await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTO_VIRTUALIZADO, dados)
            }
        }
    },
    destroyed() {
        this.$store.commit(mutationTypes.SET_EXPANDIR_MENU)
    }
}
</script>

<style scoped>
.az-container {
    margin-bottom: 60px;
}

@media (max-width: 500px) {
    .az-container {
        margin: 0;
    }
}
</style>
